module.exports = __webpack_public_path__ + "img/1493566188.c04ba3b4.jpg";